import React, { useState, useEffect, useRef } from "react";
//import Cookies from 'js-cookie';
import DeliveryLoading from '../../components/DeliveryLoading'
import SafeImage from '../../components/SafeImage';
import { BsCartCheck } from "react-icons/bs";
import styled from "styled-components";
import './styleMobile.css'
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { getCardapioPublic, getStoreInfo } from "../../services/api";
import { useQuery } from "react-query";
import Categoria from './Categoria';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';
import { setEmpresaCurrency, formatPriceWithSymbol } from '../../utils/currency';
//import 'react-toastify/dist/ReactToastify.css';

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  overflow: hidden;
  background: var(--color-surface, #fff);
`;

const Navbar = styled.div`
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    max-width: 1200px;
    left: 50%;
    transform: translateX(-50%);
    height: 60px;
    background-color: var(--color-surface, #fff);
    box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.06);
    border-top: 1px solid var(--color-border, #f0f0f0);
`;

const NavbarContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 8px;
    height: 100%;
    max-width: 500px;
    margin: 0 auto;
`;

const MainContainer = styled.div`
    overflow: hidden;
    width: 100%;
`;

const CompanyHeader = styled.div`
    background: var(--color-surface, #fff);
    width: 100%;
    max-width: 1200px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 0 16px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    border-bottom: 1px solid var(--color-border, #f0f0f0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

    @media (min-width: 768px) {
        padding: 0 24px;
    }

    .header-left {
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;
        flex: 1;
    }

    .store-logo {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
        border: 1.5px solid var(--color-border, #f0f0f0);
    }

    .store-logo-fallback {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--color-primary, #1095F3);
        color: #fff;
        font-weight: 700;
        font-size: 15px;
        letter-spacing: -0.02em;
    }

    h1 {
        color: var(--color-text, #2d2d2d);
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0px !important;
        letter-spacing: -0.02em;
        line-height: 1.2;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;
    }

    .header-icon-btn {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.2s ease;
        background: transparent;
    }

    .header-icon-btn:hover {
        background: var(--color-background, #f5f5f5);
    }

    .header-icon-btn:active {
        background: var(--color-border, #e5e7eb);
    }
`;


const Cardapio = () => {
    const { t } = useTranslation('cardapio');
    const location = useLocation();
    const { infoObjItens } = location.state || {};
    //const { itensAlreadyLoaded } = location.state || undefined;
    const navigate = useNavigate();
    //const [isLoading, setIsLoading] = useState(true);
    const scrollRef = useRef(null);
    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');
    const { nomeEmpresaForUrl, idEmpresa, slug } = useParams();
    // Identificador universal: slug (novo) ou idEmpresa (legado)
    const identifier = slug || idEmpresa;
    // Detecta se é rota nova /c/:slug
    const isSlugRoute = !!slug;

    // Detectar modo: salao ou delivery
    // - Rota nova: /c/:slug?mode=salao
    // - Rota antiga: /cardapio-salao/ (detecta pelo path)
    const modeParam = searchParams.get('mode');
    const isSalao = modeParam === 'salao' || location.pathname.includes('/cardapio-salao');
    const mode = isSalao ? 'salao' : 'delivery';

    // 🔒 ISOLAMENTO DE CONTEXTO: Detecta se é rota pública (cardápio)
    const isPublicRoute = location.pathname.startsWith('/cardapio') || location.pathname.startsWith('/c/');

    const [empresa, setEmpresa] = useState({})
    const [selectedCategoria, setSelectedCategoria] = useState('');
    const [categoriaSelecionadaPorClique, setCategoriaSelecionadaPorClique] = useState(false);

    //const [currentTime, setCurrentTime] = useState('');
    //const [horariosFuncionamento, setHorariosFuncionamento] = useState({});
    //const [openStatus, setOpenStatus] = useState('');
    const [statusLoja, setStatusLoja] = useState('');

    // 🌐 Helper i18n: Traduz scheduleInfo estruturado do backend
    const translateScheduleInfo = (info) => {
        if (!info) return '';
        switch (info.type) {
            case 'always_open':
                return t('store.alwaysOpen');
            case 'temporarily_closed':
                return t('store.schedule.temporarilyClosed');
            case 'open_until':
                return t('store.schedule.openUntil', { time: info.time });
            case 'opens_today':
                return t('store.schedule.opensToday', { time: info.time });
            case 'opens_on_day':
                return t('store.schedule.opensOnDay', {
                    day: t(`store.days.${info.day}`),
                    time: info.time,
                });
            case 'not_defined':
                return t('store.schedule.notDefined');
            default:
                return '';
        }
    };

    // Estados para pesquisa e compartilhamento
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredItens, setFilteredItens] = useState([]);
    const [filteredCategorias, setFilteredCategorias] = useState([]);

    // V2: Mega-endpoint combinado (categorias + itens + adicionais em 1 request)
    // 🔄 Cache de 2.5 minutos - equilíbrio entre performance e atualidade
    const { data: menuData, isLoading: loadingMenu, error: errorMenu } = useQuery(
        ['cardapioPublic', identifier, mode],
        async () => {
            const response = await getCardapioPublic(identifier, mode);
            return response.data;
        },
        { staleTime: 2.5 * 60 * 1000, enabled: !!identifier } // 2.5 min (150s)
    );

    // V2: Info da loja (separado pois tem cache diferente)
    // 🔄 Cache de 2.5 minutos - equilíbrio entre performance e atualidade
    const { data: empresaInfo, isLoading: loadingEmpresa, error: errorEmpresa } = useQuery(
        ['storeInfo', identifier],
        async () => {
            const response = await getStoreInfo(identifier);
            return response.data;
        },
        { staleTime: 2.5 * 60 * 1000, enabled: !!identifier } // 2.5 min (150s)
    );

    // Extrair dados do mega-endpoint
    const menuItems = menuData?.itens;
    const menuCategorias = menuData?.categorias;

    const arrayCategorias = menuCategorias
        ? [...menuCategorias].sort((a, b) => a.order - b.order)
        : undefined;

    const arrayItens = menuItems
        ? [...menuItems]
            .filter(item => {
                // No modo salão, esconder itens marcados como out_salao
                // e itens que não possuem price_salao definido
                if (isSalao) {
                    if (item.out_salao) return false;
                    if (item.price_salao == null || item.price_salao <= 0) return false;
                }
                return true;
            })
            .sort((a, b) => a.order - b.order)
        : undefined;

    const [scrollPosition, setScrollPosition] = useState(0);
    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    //COMETARIO TEMP
    useEffect(() => {
        const tabList = document.querySelector('.tab-list');
        const tabListContent = document.querySelector('.tab-list_content');
        let companyHeaderHeight = document.querySelector('.CompanyHeader');
        if (companyHeaderHeight) {
            companyHeaderHeight = companyHeaderHeight.offsetHeight;
        }
        companyHeaderHeight -= 15;
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("companyHeaderHeight",companyHeaderHeight)
        if (tabList && tabListContent) {
            if (scrollPosition >= companyHeaderHeight) {
                tabList.classList.add('fixed');
                tabListContent.classList.add('marginTop');
            } else {
                tabList.classList.remove('fixed');
                tabListContent.classList.remove('marginTop');
            }
        }

    }, [scrollPosition]);



    // UseEffect para resetar o estado de clique após o scroll (se necessário)
    useEffect(() => {
        if (categoriaSelecionadaPorClique) {
            setCategoriaSelecionadaPorClique(false);
        }
    }, [categoriaSelecionadaPorClique]);

    const scrollToCategory = (categoryId) => {
        const headerContainer = scrollRef.current;
        const selectedItem = document.getElementById(`cat:${categoryId}`);
        if (headerContainer && selectedItem) {
            const scrollPosition = selectedItem.offsetLeft - headerContainer.offsetLeft - 60;
            headerContainer.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        if (selectedCategoria) {
            scrollToCategory(selectedCategoria);
        }
    }, [selectedCategoria]);

    // Função para lidar com a seleção de categoria e scroll
    const handleSelectCategoria = (categoriaId) => {
        setSelectedCategoria(categoriaId);
        // Aqui você pode adicionar lógica adicional se necessário
    };
    // Função para realizar a rolagem direta para a categoria selecionada pelo clique
    const handleCategoriaClick = (categoriaId) => {
        setSelectedCategoria(categoriaId);
        //setIsProgrammaticScroll(true); // Indica que o próximo scroll será programático

        scrollToElement(categoriaId);
    };

    const scrollToElement = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            const headerOffset = 140;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
            });

            // Após o scroll, você pode precisar de um mecanismo para resetar isProgrammaticScroll
            // Isso pode ser feito com um callback após o scroll ou em um useEffect observando a posição do scroll
        }
    };


    useEffect(() => {
        if (!empresaInfo) return;

        setEmpresa({
            id: empresaInfo.empresaId,
            name: empresaInfo.nome,
            logo: empresaInfo.storeLogo || null,
        });

        // 🔒 ISOLAMENTO: Só salva dados sessionCompany se for rota pública
        if (isPublicRoute) {
            sessionStorage.setItem("sessionCompany", JSON.stringify(empresaInfo.empresaData));
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔐 [CARDAPIO] sessionCompany salvo com id_empresa:', empresaInfo.empresaData?.id_empresa);
        }

        // 🌐 i18n: Detectar idioma preferido da empresa
        const lang = empresaInfo.empresaData?.preferredLanguage || 'pt-BR';
        changeLanguage(lang);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🌐 [CARDAPIO] Idioma da empresa:', lang);

        // 💱 Moeda da empresa. Aqui é obrigatório setar explicitamente: no cardápio
        // público NÃO existe login, então o localStorage 'empresa' está vazio (ou,
        // pior, tem a empresa do dono que usa o mesmo navegador). A config vem do
        // endpoint público, via EMPRESA_PUBLIC_FIELDS.
        setEmpresaCurrency(empresaInfo.empresaData);

        setStatusLoja(empresaInfo.statusLoja);
        //setStatusLojaTemporario(empresaInfo.fechamentoTemporario);

        // Exibir toast SOMENTE se a loja estiver fechada
        // toastId evita duplicação ao navegar entre páginas e voltar
        if (empresaInfo.statusLoja === "fechado") {
            const scheduleText = empresaInfo.scheduleInfo
                ? translateScheduleInfo(empresaInfo.scheduleInfo)
                : empresaInfo.proximoHorario;
            toast(t('store.closedWithSchedule', { schedule: scheduleText }), {
                toastId: 'store-closed',
                autoClose: false,
                type: "error",
                position: "bottom-center"
            });
        }
    }, [empresaInfo]);

    const [itensCarrinho, setItensCarrinho] = useState([]);
    const [quantidadePedidos, setQuantidadePedidos] = useState(0);
    const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hora
    const checkPedidosCountRef = useRef(null);

    useEffect(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔄 Verificando itens no localStorage...");
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 isPublicRoute:", isPublicRoute);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 location.pathname:", location.pathname);

        const now = Date.now();
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⏰ Timestamp atual:", now, "=>", new Date(now));
        
        // DEBUG ESPECÍFICO: Testar timestamp do usuário
        const userTimestamp = 1757447699725;
        const userAge = now - userTimestamp;
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 DEBUG TIMESTAMP DO USUÁRIO:");
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Timestamp:", userTimestamp);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Data:", new Date(userTimestamp));
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Idade em ms:", userAge);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Idade em minutos:", Math.round(userAge / (1000 * 60)));
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Expira em 60min? (EXPIRATION_TIME):", EXPIRATION_TIME / (1000 * 60));
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("- Está expirado?", userAge >= EXPIRATION_TIME);
        
        // ✅ SIMPLICIDADE: Usar APENAS uma chave consistente
        const storageKey = 'itensCarrinhoMobile';
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔑 Chave do localStorage:", storageKey);
        
        // 🧹 LIMPEZA: Remover chaves inconsistentes que possam existir
        if (localStorage.getItem('itensCarrinhoMobile_public')) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🧹 Removendo chave inconsistente itensCarrinhoMobile_public");
            localStorage.removeItem('itensCarrinhoMobile_public');
        }
        
        // ✅ LEITURA DIRETA: Apenas uma chave para ler
        const itensCarrinhoTemp = localStorage.getItem(storageKey) 
            ? JSON.parse(localStorage.getItem(storageKey)) 
            : [];
        
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛒 Itens do carrinho lidos:", itensCarrinhoTemp);

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📦 Itens encontrados na chave", storageKey, ":", itensCarrinhoTemp);

        // DEBUG: Analisar cada item individualmente
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 Analisando expiração de cada item:");
        itensCarrinhoTemp.forEach((item, index) => {
            const itemAge = now - item.addedAt;
            const isExpired = itemAge >= EXPIRATION_TIME;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`📦 Item ${index + 1}:`, {
                title: item.title,
                addedAt: item.addedAt,
                addedAtDate: new Date(item.addedAt),
                age: itemAge,
                ageInMinutes: Math.round(itemAge / (1000 * 60)),
                EXPIRATION_TIME: EXPIRATION_TIME,
                expirationInMinutes: EXPIRATION_TIME / (1000 * 60),
                isExpired: isExpired
            });
        });
        
        // Filtra apenas os itens que ainda estão dentro do tempo de expiração
        const itensFiltrados = itensCarrinhoTemp.filter(item => now - item.addedAt < EXPIRATION_TIME);

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Itens após remover os expirados:", itensFiltrados);

        // Atualiza o estado e o localStorage
        setItensCarrinho(itensFiltrados);
        
        // ✅ SALVAR: Sempre na mesma chave consistente
        localStorage.setItem(storageKey, JSON.stringify(itensFiltrados));
        
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛒 Contador do carrinho atualizado:", itensFiltrados.length);
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎯 Estado final itensCarrinho.length:", itensFiltrados.length);
    }, [EXPIRATION_TIME, isPublicRoute]);

    // useEffect para verificar pedidos no localStorage usando session_token
    useEffect(() => {
        const checkPedidosCount = async (forceRefresh = false) => {
            const sessionToken = localStorage.getItem('session_token_pedeja');
            
            if (!sessionToken) {
                setQuantidadePedidos(0);
                return;
            }

            // 🚀 EXIBIÇÃO IMEDIATA: Buscar no localStorage primeiro
            const cachedPedidos = localStorage.getItem(`pedidos_cache_${sessionToken}`);
            let contadorAtualLocalStorage = 0;
            
            if (cachedPedidos) {
                try {
                    const pedidosData = JSON.parse(cachedPedidos);
                    const now = Date.now();
                    
                    // ✅ SEMPRE EXIBIR CACHE PRIMEIRO (mesmo expirado)
                    const pedidosAtivos = pedidosData.pedidos.filter(p => 
                        ['1', '2', '3'].includes(p.status_pedido)
                    );
                    contadorAtualLocalStorage = pedidosAtivos.length;
                    setQuantidadePedidos(contadorAtualLocalStorage);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚡ Exibição imediata do cache:', contadorAtualLocalStorage, 'pedidos');
                    
                    // Se cache é válido (5 min) E não é refresh forçado, não buscar servidor
                    if (now - pedidosData.timestamp < 5 * 60 * 1000 && !forceRefresh) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ Cache válido - não buscar servidor');
                        return;
                    }
                } catch (error) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao parsear cache de pedidos:', error);
                }
            }
            
            // 🔄 SINCRONIZAÇÃO COM SERVIDOR: Buscar dados atualizados em background
            try {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('📊 Sincronizando com servidor em background...');
                const { trackPedidosPublic } = await import('../../services/api');
                const response = await trackPedidosPublic(sessionToken);
                
                if (response.data && response.data.pedidos) {
                    // Contar apenas pedidos em andamento
                    const pedidosAtivosServidor = response.data.pedidos.filter(p => 
                        ['1', '2', '3'].includes(p.status_pedido)
                    );
                    const contadorServidor = pedidosAtivosServidor.length;
                    
                    // ✅ DETECTAR MUDANÇAS: Só atualizar se houver diferença
                    if (contadorServidor !== contadorAtualLocalStorage) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`🔄 Inconsistência detectada! Cache: ${contadorAtualLocalStorage}, Servidor: ${contadorServidor}`);
                        setQuantidadePedidos(contadorServidor);
                    } else {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ Cache e servidor sincronizados:', contadorServidor, 'pedidos');
                    }
                    
                    // 💾 ATUALIZAR CACHE: Sempre salvar dados mais recentes
                    const cacheData = {
                        pedidos: response.data.pedidos,
                        timestamp: Date.now()
                    };
                    localStorage.setItem(`pedidos_cache_${sessionToken}`, JSON.stringify(cacheData));
                    
                } else {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚠️ Servidor retornou dados vazios');
                    if (contadorAtualLocalStorage === 0) {
                        setQuantidadePedidos(0);
                    }
                    // Se localStorage tinha valor mas servidor está vazio, manter localStorage temporariamente
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('❌ Erro ao sincronizar com servidor:', error);
                // Em caso de erro de rede, manter valor do localStorage
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔒 Mantendo valor do cache local devido a erro de rede');
            }
        };

        // Armazenar função na ref para uso externo
        checkPedidosCountRef.current = checkPedidosCount;

        checkPedidosCount();
        
        // Verificar a cada minuto para atualizações
        const interval = setInterval(checkPedidosCount, 60000);
        
        // Listener para mudanças no localStorage (quando pedido é finalizado em outra aba/tela)
        const handleStorageChange = (e) => {
            if (e.key && e.key.startsWith('pedidos_cache_')) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Cache de pedidos atualizado - atualizando contador');
                checkPedidosCount();
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        
        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // useEffect para atualizar contador quando voltar para a tela (ex: depois de finalizar pedido)
    useEffect(() => {
        const handleFocus = () => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔍 Tela recebeu foco - verificando pedidos...');
            const sessionToken = localStorage.getItem('session_token_pedeja');
            if (sessionToken) {
                // Forçar nova verificação removendo cache temporariamente
                const cacheKey = `pedidos_cache_${sessionToken}`;
                const existingCache = localStorage.getItem(cacheKey);
                if (existingCache) {
                    localStorage.removeItem(cacheKey);
                    setTimeout(() => {
                        // Reexecutar checkPedidosCount após limpar cache
                        const event = new Event('storage');
                        event.key = cacheKey;
                        window.dispatchEvent(event);
                    }, 100);
                }
            }
        };

        window.addEventListener('focus', handleFocus);
        
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    // useEffect para detectar retorno de outras telas (como finalização de pedido)
    useEffect(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Index.jsx recarregado - verificando se há novos pedidos...');
        const sessionToken = localStorage.getItem('session_token_pedeja');
        
        if (sessionToken) {
            // Pequeno delay para garantir que session_token foi salvo antes da verificação
            setTimeout(() => {
                const cacheKey = `pedidos_cache_${sessionToken}`;
                const existingCache = localStorage.getItem(cacheKey);
                
                if (!existingCache) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🚀 Sem cache encontrado - forçando busca de pedidos...');
                    // Disparar evento para reexecutar checkPedidosCount
                    const event = new Event('storage');
                    event.key = cacheKey;
                    window.dispatchEvent(event);
                }
            }, 1000);
        }
    }, [location.pathname]); // Reexecuta quando a URL muda

    // useEffect final: verificação adicional para casos edge
    useEffect(() => {
        const sessionToken = localStorage.getItem('session_token_pedeja');
        
        if (sessionToken && quantidadePedidos === 0) {
            // Aguardar 3 segundos e se ainda estiver 0, forçar refresh
            const timer = setTimeout(() => {
                if (quantidadePedidos === 0) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔄 Contador ainda em 0 - forçando atualização...');
                    if (checkPedidosCountRef.current) {
                        checkPedidosCountRef.current(true); // forceRefresh = true
                    }
                }
            }, 3000);
            
            return () => clearTimeout(timer);
        }
    }, [quantidadePedidos]);

    /*const handleCarrinho = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(nomeEmpresaForUrl, idEmpresa)
        navigate("/cardapio/"+nomeEmpresaForUrl+"/"+idEmpresa+"/carrinho", {state: { infoObjItens }});
    }

    const handleOpenProfile = () => {
        navigate("/cardapio/"+nomeEmpresaForUrl+"/"+idEmpresa+"/info-loja", {state: { infoEmpresa: empresa}});
    }*/
    // Helper para construir URLs (suporta /c/:slug e /cardapio/:nome/:id)
    // Preserva query params importantes: external_id e mode
    // 🔧 FIX: Com fallback para sessionStorage
    const buildUrl = (subpath) => {
        let base;
        if (isSlugRoute && slug) {
            base = `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
        } else {
            // Fallback: buscar do sessionStorage
            try {
                const empresaData = sessionStorage.getItem('sessionCompany');
                if (empresaData) {
                    const parsed = JSON.parse(empresaData);
                    if (parsed?.slug) {
                        base = `/c/${parsed.slug}/${subpath}`;
                    } else if (parsed?.name && parsed?.id_empresa) {
                        const nomeForUrl = parsed.name.toLowerCase().replace(/\s+/g, '-');
                        base = `/cardapio/${nomeForUrl}/${parsed.id_empresa}/${subpath}`;
                    }
                }
            } catch (e) {
                console.error('[CARDAPIO] Erro ao construir URL:', e);
            }
            if (!base) {
                console.warn('[CARDAPIO] buildUrl: Não foi possível construir URL válida para:', subpath);
                base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
            }
        }
        const params = new URLSearchParams();
        if (externalId) params.set('external_id', externalId);
        if (isSalao) params.set('mode', 'salao');
        const qs = params.toString();
        return qs ? `${base}?${qs}` : base;
    };

    const handleCarrinho = () => {
        navigate(buildUrl('carrinho'), { state: { infoObjItens } });
    }

    const handleOpenProfile = () => {
        navigate(buildUrl('info-loja'), { state: { infoEmpresa: empresaInfo?.empresaData, storeLogo: empresaInfo?.storeLogo || empresa?.logo } });
    }

    const handleMeusPedidos = () => {
        navigate(buildUrl('meus-pedidos'));
    }



    // Função para alternar a exibição da pesquisa
    const handleToggleSearch = () => {
        setShowSearch(!showSearch);
        if (showSearch) {
            setSearchQuery('');
            setFilteredItens([]);
            setFilteredCategorias([]);
        }
    };

    // Função para realizar a pesquisa
    const handleSearch = (query) => {
        setSearchQuery(query);
        
        if (!query.trim()) {
            setFilteredItens([]);
            setFilteredCategorias([]);
            return;
        }

        const queryLower = query.toLowerCase();
        
        // Filtrar itens
        const itemsFiltered = arrayItens?.filter(item => 
            item.title.toLowerCase().includes(queryLower) ||
            item.description?.toLowerCase().includes(queryLower)
        ) || [];
        
        // Filtrar categorias
        const categoriasFiltered = arrayCategorias?.filter(categoria =>
            categoria.title.toLowerCase().includes(queryLower)
        ) || [];
        
        setFilteredItens(itemsFiltered);
        setFilteredCategorias(categoriasFiltered);
    };

    // Função para compartilhar
    const handleShare = async () => {
        const shareData = {
            title: `${empresa?.name || t('share.defaultTitle')}`,
            text: t('share.text', { name: empresa?.name || t('share.defaultStoreName') }),
            url: window.location.href
        };

        try {
            // Primeiro tenta usar a Web Share API nativa (funciona bem no iOS)
            if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
                await navigator.share(shareData);
                return;
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Web Share API falhou, tentando clipboard...');
        }

        // Fallback para clipboard
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(window.location.href);
                toast.success(t('store.linkCopied'), {
                    position: 'bottom-center',
                    autoClose: 2000
                });
                return;
            }
        } catch (clipboardError) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Clipboard API falhou, usando fallback manual...');
        }

        // Fallback manual para iOS e navegadores antigos
        try {
            const textArea = document.createElement('textarea');
            textArea.value = window.location.href;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            
            if (successful) {
                toast.success(t('store.linkCopied'), {
                    position: 'bottom-center',
                    autoClose: 2000
                });
            } else {
                throw new Error('Comando copy falhou');
            }
        } catch (fallbackError) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Todos os métodos de compartilhamento falharam:', fallbackError);
            // Último recurso: mostrar o link para o usuário copiar manualmente
            const link = window.location.href;
            toast.info(t('store.copyLink', { link }), {
                position: 'bottom-center',
                autoClose: 8000
            });
        }
    };

    /*function findNextClosingTime(schedule, currentTime) {
        if (!currentTime || currentTime === "") {
            setLoadingData(true);
            return "Carregando...";  // Ensure currentTime is available
        }

        // Corrigindo a obtenção do dia da semana para usar getDay()
        const weekDays = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];
        const now = new Date(currentTime);
        const currentDayIndex = now.getDay();
        const currentDayName = weekDays[currentDayIndex];

        const currentDaySchedules = schedule[currentDayName];

        if (currentDaySchedules) {
            for (const period of currentDaySchedules) {
                const startDateString = currentTime.split(' ')[0] + 'T' + period.start + ':00'; // Incluindo segundos
                const endDateString = currentTime.split(' ')[0] + 'T' + period.end + ':00'; // Incluindo segundos
                const startTime = new Date(startDateString);
                let endTime = new Date(endDateString);

                if (endTime < startTime) {
                    endTime.setDate(endTime.getDate() + 1);  // Ajustando para horários que cruzam a meia-noite
                }

                if (now >= startTime && now < endTime) {
                    setStatusLoja("aberto");
                    setLoadingData(false);
                    return `Aberto até ${endTime.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
                }
            }
        }

        // Se nenhum período válido foi encontrado para o dia atual
        setStatusLoja("fechado");
        setLoadingData(false);
        if (!toastShown) {
            toast("O estabelecimento está fechado.", { autoClose: false, type: 'error', position: 'bottom-center' });
            setToastShown(true);
        }
        return "Fechado";
    }


    function findNextOpeningTime(schedule, currentTime) {
        if (!currentTime || currentTime === "") {
            setLoadingData(true);
            return "Carregando...";  // Ensure currentTime is available
        }
        const weekDays = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];
        const now = new Date(currentTime);
        const currentDayIndex = now.getDay();
        let result = "Sem horário de abertura próximo";
        let daysChecked = 0;

        while (daysChecked < 7) {  // Only need to check one full week
            const checkDay = (currentDayIndex + daysChecked) % 7;
            const dayName = weekDays[checkDay];
            const periods = schedule[dayName];
            if (periods) {
                for (const period of periods) {
                    // Calculate the correct date for the period being checked
                    const checkDate = new Date(now);
                    checkDate.setDate(now.getDate() + daysChecked);
                    const startDateString = checkDate.toISOString().split('T')[0] + 'T' + period.start + ':00'; // Ensure seconds are included
                    const endDateString = checkDate.toISOString().split('T')[0] + 'T' + period.end + ':00'; // Ensure seconds are included
                    const startTime = new Date(startDateString);
                    const endTime = new Date(endDateString);

                    // Correct the day if the period crosses midnight
                    if (period.end < period.start) {
                        endTime.setDate(endTime.getDate() + 1);
                    }

                    // If currentTime is during a closing period, skip to the next period
                    if (now >= endTime) {
                        continue;
                    }

                    // If current time is earlier than the start time, we found our next opening time
                    if (now < startTime) {
                        const nextOpenDay = daysChecked === 0 ? "hoje" : weekDays[(currentDayIndex + daysChecked) % 7];
                        result = `Abre ${nextOpenDay} às ${startTime.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
                        setLoadingData(false);
                        return result;
                    }
                }
            }
            daysChecked++;
        }

        // If all days were checked and no future time was found
        setStatusLoja("fechado");
        setLoadingData(false);
        if (!toastShown) {
            toast("O estabelecimento está fechado.", { autoClose: false, type: 'error', position: 'bottom-center' });
            setToastShown(true);
        }
        return result;
    }*/




    if (loadingMenu || loadingEmpresa) {
        return <DeliveryLoading inline message={t('loadingMenu')} />;
    }

    if (errorMenu || errorEmpresa) return t('store.errorOccurred') + (errorMenu?.message || errorEmpresa?.message);

    else

        return (
            <Container>
                <Navbar>
                    <div style={{ width: '100%', height: 'inherit' }}>
                        <NavbarContent>
                            <div className="nav-inicio">
                                <div className="icon-ativo" />

                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={20}
                                        height={20}
                                        viewBox="0 0 19.195 18"
                                    >
                                        <g id="Home" transform="translate(-8.999 -10)">
                                            <path
                                                id="Icon"
                                                d="M16.622,18H2.57a1.319,1.319,0,0,1-1.317-1.318V9.657a1.317,1.317,0,0,1-.79-2.318L8.744.312a1.318,1.318,0,0,1,1.7,0L18.73,7.339a1.32,1.32,0,0,1-.79,2.323v7.021A1.319,1.319,0,0,1,16.622,18ZM8.279,11.417h2.635a1.319,1.319,0,0,1,1.317,1.318v3.952h4.391V8.344h1.256L9.6,1.319,1.315,8.344H2.57v8.343H6.962V12.735A1.319,1.319,0,0,1,8.279,11.417Zm0,1.318v3.952h2.635V12.735Z"
                                                transform="translate(9 10)"
                                                fill="#1095F3"
                                            />
                                        </g>
                                    </svg>

                                </div>

                                <span style={{
                                    color: 'grey',
                                    fontSize: '10px',
                                    fontWeight: '500'
                                }}
                                >
                                    {t('nav.home')}
                                </span>

                            </div>

                            {/* No modo salão, cardápio é apenas para visualização - sem carrinho/pedidos */}
                            {!isSalao && (
                                <div className="nav-meus-pedidos" onClick={() => handleMeusPedidos()}>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <BsCartCheck fill="#9C9C9C" style={{width:20, height:20}}/>
                                    </div>

                                    <span style={{
                                        color: 'grey',
                                        fontSize: '10px',
                                        fontWeight: '500'
                                    }}>
                                        {t('nav.myOrders')}
                                        {quantidadePedidos > 0 &&
                                            <>
                                                <i className="counterItensCarrinhoNum">{quantidadePedidos}</i>
                                                <i className="counterItensCarrinhoNumAnimated" />
                                            </>
                                        }
                                    </span>
                                </div>
                            )}

                            {!isSalao && (
                                <div className="nav-carrinho" onClick={() => handleCarrinho()}>
                                    {/*<div className="icon-ativo"/>*/}

                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={20}
                                            height={20}
                                            viewBox="0 0 23.326 20"
                                        >
                                            <path
                                                id="Shape"
                                                d="M8.454,20h0a2.563,2.563,0,0,1-2.563-2.567,6.2,6.2,0,0,0,.584-5.2L1.795,1.538H.77A.769.769,0,1,1,.77,0H2.308a.768.768,0,0,1,.7.462L4.036,2.82a1.535,1.535,0,0,1,.831-.256h16.92A1.538,1.538,0,0,1,23.2,4.707l-3.076,7.178a1.537,1.537,0,0,1-1.415.933H8.475a1.026,1.026,0,0,0,0,2.051H18.746a2.563,2.563,0,1,1-2.38,1.538H10.8A2.564,2.564,0,0,1,8.454,20ZM18.71,16.408a1.026,1.026,0,1,0,1.025,1.025A1.027,1.027,0,0,0,18.71,16.408Zm-10.255,0a1.026,1.026,0,1,0,1.025,1.025A1.027,1.027,0,0,0,8.455,16.408ZM4.866,4.1l3.076,7.178H18.71L21.786,4.1H4.866Z"
                                                fill="#9C9C9C"
                                            />
                                        </svg>

                                    </div>

                                    <span style={{
                                        color: 'grey',
                                        fontSize: '10px',
                                        fontWeight: '500'
                                    }}
                                    >
                                        {t('nav.cart')}
                                        {itensCarrinho.length > 0 &&
                                            <>
                                                <i className="counterItensCarrinhoNum">{itensCarrinho.length}</i>
                                                <i className="counterItensCarrinhoNumAnimated" />
                                            </>
                                        }
                                    </span>

                                </div>
                            )}

                        </NavbarContent>

                    </div>
                </Navbar>

                <MainContainer>
                    <div>
                        <div className="header-wrapper">
                            <CompanyHeader className="CompanyHeader">
                                <div className="header-left">
                                    <SafeImage
                                        className="store-logo"
                                        src={empresa?.logo}
                                        alt={empresa?.name}
                                        fallback={
                                            <div className="store-logo-fallback">
                                                {empresa?.name ? empresa.name.charAt(0).toUpperCase() : '?'}
                                            </div>
                                        }
                                    />
                                    <h1>{empresa && empresa.name}</h1>
                                </div>
                                <div className="header-actions">
                                    <div className="header-icon-btn" onClick={handleToggleSearch}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx={11} cy={11} r={8} /><line x1={21} y1={21} x2="16.65" y2="16.65" />
                                        </svg>
                                    </div>
                                    <div className="header-icon-btn" onClick={handleShare}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx={18} cy={5} r={3} /><circle cx={6} cy={12} r={3} /><circle cx={18} cy={19} r={3} />
                                            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                                        </svg>
                                    </div>
                                </div>
                            </CompanyHeader>

                            <div className="company-info">
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span className="text-mobile">
                                        {empresaInfo
                                            ? (empresaInfo.scheduleInfo
                                                ? translateScheduleInfo(empresaInfo.scheduleInfo)
                                                : empresaInfo.proximoHorario)
                                            : t('store.loading')}
                                    </span>
                                    <span className="dot"></span>
                                    <span className="text-mobile">
                                        {empresaInfo?.empresaData?.pedido_minimo > 0
                                            ? t('store.minimumOrder', { value: formatPriceWithSymbol(empresaInfo.empresaData.pedido_minimo) })
                                            : t('store.noMinimumOrder')
                                        }
                                    </span>
                                </div>
                                <div className="linkPerfilLoja" onClick={() => handleOpenProfile()}>{t('nav.storeProfile')}</div>
                            </div>

                            {/* Barra de pesquisa */}
                            {showSearch && (
                                <div className="search-container">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder={t('search.placeholder')}
                                            value={searchQuery}
                                            onChange={(e) => handleSearch(e.target.value)}
                                            className="search-input"
                                            autoFocus
                                        />
                                        <button onClick={handleToggleSearch} className="search-close-btn">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                                <line x1="6" y1="6" x2="18" y2="18"></line>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}


                        </div>

                        <div className="tab-wrapper" style={{paddingTop: showSearch ? '88px' : '0'}}>
                            <div>
                                {/* Resultados da pesquisa */}
                                {showSearch && searchQuery ? (
                                    <div className="search-results">
                                        {/* Categorias encontradas com seus itens */}
                                        {filteredCategorias.map((categoria) => {
                                            const itensCategoria = arrayItens?.filter(item => item.category_item_id === categoria._id) || [];
                                            return (
                                                <div key={categoria._id} className="categoria-container">
                                                    <Categoria
                                                        categoria={categoria}
                                                        itens={itensCategoria}
                                                        nomeEmpresaForUrl={nomeEmpresaForUrl || slug}
                                                        idEmpresa={idEmpresa || slug}
                                                        slug={slug}
                                                        isSlugRoute={isSlugRoute}
                                                        mode={mode}
                                                        handleSelectCategoria={handleSelectCategoria}
                                                        statusLoja={statusLoja}
                                                    />
                                                </div>
                                            );
                                        })}
                                        
                                        {/* Itens encontrados agrupados por categoria */}
                                        {filteredItens.length > 0 && (
                                            <>
                                                {/* Agrupar itens por categoria */}
                                                {Object.entries(
                                                    filteredItens.reduce((acc, item) => {
                                                        const categoria = arrayCategorias?.find(cat => cat._id === item.category_item_id);
                                                        if (categoria && !filteredCategorias.find(cat => cat._id === categoria._id)) {
                                                            const categoryKey = categoria._id;
                                                            if (!acc[categoryKey]) {
                                                                acc[categoryKey] = {
                                                                    categoria: categoria,
                                                                    itens: []
                                                                };
                                                            }
                                                            acc[categoryKey].itens.push(item);
                                                        }
                                                        return acc;
                                                    }, {})
                                                ).map(([categoryKey, { categoria, itens }]) => (
                                                    <div key={categoryKey} className="categoria-container">
                                                        <Categoria
                                                            categoria={categoria}
                                                            itens={itens}
                                                            nomeEmpresaForUrl={nomeEmpresaForUrl}
                                                            idEmpresa={idEmpresa}
                                                            slug={slug}
                                                            isSlugRoute={isSlugRoute}
                                                            mode={mode}
                                                            handleSelectCategoria={handleSelectCategoria}
                                                            statusLoja={statusLoja}
                                                        />
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        
                                        {filteredCategorias.length === 0 && filteredItens.length === 0 && (
                                            <div className="search-no-results">
                                                <p>{t('search.noResults', { query: searchQuery })}</p>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        <div className={"tab-list"} ref={scrollRef}>
                                            <ul className="tab-item-list">
                                                {arrayCategorias && arrayCategorias.filter((cats) =>
                                                    menuItems && menuItems.some((item) => item.category_item_id === cats._id)
                                                )
                                                    .map((categoria, i) => (
                                                        <li key={categoria._id} id={`cat:${categoria._id}`} className="tab-list_item"
                                                            onClick={() => handleCategoriaClick(categoria._id)}>
                                                            <span className="tab-list_item_categoria_nome"
                                                                style={{ color: selectedCategoria === categoria._id ? "#1095F3" : "#9ca3af", transition: "color 0.2s ease" }}
                                                            >{categoria.title}</span>
                                                            {selectedCategoria === categoria._id ?
                                                                <div className="tab-list_item_ativo" />
                                                                : null}
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                        <div className={"tab-list_content"}>
                                            <div className="categoria-container">
                                                {arrayCategorias && arrayCategorias
                                                    .filter((category) =>
                                                        menuItems && menuItems.some((item) => item.category_item_id === category._id)
                                                    )
                                                    .map((categoria, i) => (
                                                        <Categoria
                                                            key={categoria._id}
                                                            categoria={categoria}
                                                            itens={arrayItens}
                                                            nomeEmpresaForUrl={nomeEmpresaForUrl}
                                                            idEmpresa={idEmpresa}
                                                            slug={slug}
                                                            isSlugRoute={isSlugRoute}
                                                            mode={mode}
                                                            handleSelectCategoria={handleSelectCategoria}
                                                            statusLoja={statusLoja}
                                                        />
                                                    ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>
                </MainContainer>

            </Container>
        );
};


export default Cardapio;